import type { StateCreator } from "zustand";

export interface LeftAxisSlice {
    leftAxisSelections: Record<string, string>;
    setLeftAxisSelection: (panelId: string, axisId: string) => void;
}

export const createLeftAxisSlice: StateCreator<LeftAxisSlice, [], [], LeftAxisSlice> = (set) => ({
    leftAxisSelections: {},
    setLeftAxisSelection: (panelId, axisId) =>
        set((state) => ({
            leftAxisSelections: { ...state.leftAxisSelections, [panelId]: axisId },
        })),
});
